import isBrowserContext from "helpers/isBrowserContext";
import { createRef, useEffect } from "react";

export default (callback: (event: MouseEvent | TouchEvent) => void) => {
    const innerElementRef = createRef<any>();

    useEffect(() => {
        const listener = (event: MouseEvent | TouchEvent) => {
            const el = innerElementRef?.current;

            // Do nothing if clicking ref's element or descendent elements
            if (!el || el.contains(event.target as Node)) {
                return;
            }

            callback(event);
        };

        if (isBrowserContext()) {
            document.addEventListener("click", listener);
            document.addEventListener("touchend", listener);
        }

        return () => {
            if (isBrowserContext()) {
                document.removeEventListener("click", listener);
                document.removeEventListener("touchend", listener);
            }
        };
    }, [innerElementRef, callback]);

    return innerElementRef;
};